import { all, call, put, takeLatest } from 'redux-saga/effects'

import {
    deleteRequest,
    getRequest,
    getRequestV2,
    postRequest,
    postRequestV2,
    putRequest,
    putRequestV2,
    serializeApiError,
} from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { startErrorAlert } from 'redux/alert/alert-actions'

import * as allAssetsActions from '../allAssets/allAssets-actions.js'
import * as dashboardActions from '../dashboard/dashboard-actions.js'
import UserActionTypes from '../user/user-types'

import * as cardsActions from './cards-actions'
import CardsActionTypes from './cards-types'

function* startCardOrder({ payload }) {
    try {
        if (payload.cardType === 'virtual') {
            yield postRequest(`/user/assets/cards/${payload.cardType}`, {
                programId: payload.programId,
                currencyCode: payload.currencyCode,
                shippingType: payload.shippingType,
                addressNo: payload.addressNo,
                debitAccountId: payload.debitAccountId,
                companyMemberUserAccountId: payload.companyMemberId,
            })
        } else {
            yield postRequestV2(`/user/assets/cards/${payload.cardType}`, {
                programId: payload.programId,
                currencyCode: payload.currencyCode,
                shippingType: payload.shippingType,
                addressNo: payload.addressNo,
                debitAccountId: payload.debitAccountId,
                companyMemberUserAccountId: payload.companyMemberId,
                fourthLineText: payload.fourthLineText,
            })
        }
        yield put(cardsActions.successCardOrder())
        yield put(allAssetsActions.startFetchAllAssets())
    } catch (err) {
        yield put(cardsActions.failureCardOrder({ errorMessage: err?.response?.data?.errors }))
        yield put(startErrorAlert([{ message: serializeApiError(err) }]))
        if (!IS_PRODUCTION) {
            console.log('error order card', err)
        }
    }
}

export function* onOrderCard() {
    yield takeLatest(CardsActionTypes.START_CARD_ORDER, startCardOrder)
}

function* startCardBalanceTopUp({ payload: { identifier, amount, currencyCode, sourceAccountId } }) {
    try {
        const { data } = yield postRequest(`/user/assets/cards/${identifier}/deposits`, {
            amount: { currencyCode, value: amount },
            sourceAccountId,
        })
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield put(cardsActions.successCardTopUp(transactionData))
    } catch (err) {
        yield put(cardsActions.failureCardTopUp({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error topup card balance')
        }
    }
}

export function* onStartCardBalanceTopUp() {
    yield takeLatest(CardsActionTypes.START_CARD_TOP_UP, startCardBalanceTopUp)
}

function* startCardBalanceWithdraw({ payload: { identifier, targetAccountId, amount, currencyCode, cardNumber, type } }) {
    try {
        const { data } = yield postRequest(`/user/assets/cards/${identifier}/withdrawals`, {
            amount: { currencyCode, value: amount },
            targetAccountId,
        })
        const { data: transactionData } = yield getRequestV2(`/user/assets/transfers/${data.no}`)

        yield (transactionData.orderType = 'withdraw')
        yield put(cardsActions.successCardWithdraw({ cardNumber, type, successData: transactionData }))
    } catch (err) {
        yield put(cardsActions.failureCardWithraw({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error withdraw card balance')
        }
    }
}

export function* onStartCardBalanceWithdraw() {
    yield takeLatest(CardsActionTypes.START_CARD_WITHDRAW, startCardBalanceWithdraw)
}

function* startCardFreeze({ payload: { identifier } }) {
    try {
        yield putRequest(`/user/assets/cards/${identifier}/freeze`)
        yield put(cardsActions.successCardFreeze())
        yield put(cardsActions.finishCardFreeze())
        yield put(allAssetsActions.startFetchAllAssets())
        yield put(cardsActions.startGetCard({ identifier }))
    } catch (err) {
        yield put(cardsActions.failureCardFreeze({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error Card freeze')
        }
    }
}

export function* onStartCardFreeze() {
    yield takeLatest(CardsActionTypes.START_CARD_FREEZE, startCardFreeze)
}

function* startCardUnfreeze({ payload: { identifier } }) {
    try {
        yield putRequest(`/user/assets/cards/${identifier}/unfreeze`)
        yield put(cardsActions.successCardUnfreeze())
        yield put(cardsActions.finishCardUnfreeze())
        yield put(allAssetsActions.startFetchAllAssets())
        yield put(cardsActions.startGetCard({ identifier }))
    } catch (err) {
        yield put(cardsActions.failureCardUnfreeze({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error Card Unfreeze')
        }
    }
}

export function* onStartCardUnFreeze() {
    yield takeLatest(CardsActionTypes.START_CARD_UNFREEZE, startCardUnfreeze)
}

function* startCardActivation({ payload: { identifier, cvc, verificationCode } }) {
    try {
        yield putRequestV2(`/user/assets/cards/${identifier}/activate`, { cvv: cvc, verificationCode })
        const { data } = yield getRequest('/user/assets/cards')

        yield put(cardsActions.successCardActivation({ successData: data }))
    } catch (err) {
        yield put(cardsActions.failureCardActivation({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error startCardActivation')
        }
    }
}

export function* onStartCardActivation() {
    yield takeLatest(CardsActionTypes.START_CARD_ACTIVATION, startCardActivation)
}

function* startCardDeactivate({ payload: { identifier } }) {
    try {
        yield deleteRequest(`/user/assets/cards/${identifier}`)
        yield put(cardsActions.successCardDeactivate({ identifier, status: 'Deactivated' }))
        yield put(dashboardActions.startFetchDashboards())
    } catch (err) {
        yield put(cardsActions.failureCardDeactivate({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('Error Card Deactivate')
        }
    }
}
export function* onStartCardDeactivate() {
    yield takeLatest(CardsActionTypes.START_CARD_DEACTIVATE, startCardDeactivate)
}

function* startCardDetails({ payload: { identifier, verificationCode } }) {
    try {
        const { data } = yield postRequestV2(`/user/assets/cards/${identifier}/reveal`, { verificationCode })

        yield put(cardsActions.successCardDetails(data))
    } catch (err) {
        yield put(cardsActions.failureCardDetails({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error startCardDetails')
        }
    }
}
export function* onStartCardDetails() {
    yield takeLatest(CardsActionTypes.START_CARD_DETAILS, startCardDetails)
}

function* startReceivePin({ payload: { identifier, verificationCode } }) {
    try {
        const { data } = yield postRequestV2(`/user/assets/cards/${identifier}/pin`, { verificationCode })

        yield put(cardsActions.successReceivePin(data.pin))
    } catch (err) {
        yield put(cardsActions.failureReceivePin({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error receive pin')
        }
    }
}
export function* onStartReceivePin() {
    yield takeLatest(CardsActionTypes.START_RECEIVE_PIN, startReceivePin)
}

function* startGetCard({ payload: { identifier } }) {
    try {
        const { data } = yield getRequest(`/user/assets/cards/${identifier}`)

        yield put(cardsActions.successGetCard(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('error getCardPrograms', err)
        }
    }
}
export function* onStartGetCard() {
    yield takeLatest(CardsActionTypes.START_GET_CARD, startGetCard)
}

function* getCardPrograms() {
    try {
        const { data } = yield getRequest('/user/assets/cards/programs')

        yield put(cardsActions.successCardPrograms(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('error getCardPrograms', err)
        }
    }
}
export function* onGetCardPrograms() {
    yield takeLatest(CardsActionTypes.GET_CARD_PROGRAMS, getCardPrograms)
}

function* getCardShipping() {
    try {
        const { data } = yield getRequestV2('/user/assets/cards/shipping')

        yield put(cardsActions.successCardShipping(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('error getCardShipping', err)
        }
    }
}
export function* onGetCardShipping() {
    yield takeLatest(CardsActionTypes.GET_CARD_SHIPPING, getCardShipping)
}

function* fetchData() {
    yield
}
export function* onSignSuccess() {
    yield takeLatest(UserActionTypes.SIGN_IN_SUCCESS, fetchData)
}

export function* cardsSagas() {
    yield all([
        call(onStartCardBalanceTopUp),
        call(onStartCardBalanceWithdraw),
        call(onStartCardActivation),
        call(onStartCardFreeze),
        call(onStartCardUnFreeze),
        call(onStartCardDeactivate),
        call(onStartCardDetails),
        call(onOrderCard),
        call(onSignSuccess),
        call(onStartReceivePin),
        call(onStartGetCard),
        call(onGetCardPrograms),
        call(onGetCardShipping),
    ])
}
